<cc-top-bar [title]="'RECORDS_LIST.CONTACT_DETAILS_TITLE' | translate">
    <cc-top-bar-item title="{{ 'MENU.SETTINGS' | translate }}" class="settings">
      <button mat-button [matMenuTriggerFor]="menu"><i class="material-icons settings" >settings</i></button>
      <mat-menu #menu="matMenu" class="settings-menu">
        <button mat-menu-item (click)="confirmToDelete()">
          <i class="fas fa-trash-alt"></i>
          <span>{{'CONTACTS.DELETE.HEADER' | translate}}</span>
        </button>
        <button mat-menu-item (click)="getPdf()">
          <i class="fas fa-sign-in-alt"></i>
          <span>{{'CONTACTS.DOWNLOAD.PDF' | translate}}</span>
        </button>
      </mat-menu>
    </cc-top-bar-item>
</cc-top-bar>
<div class="details">
  <div class="details-back">
    <button class="btn button-back channels-button"
            (click)="back()" translate="BACK"></button>
  </div>
  <div class="details-content">
    <div class="details-content--left">
      <cc-number-details [recordId]="recordId" [data]="generalData"></cc-number-details>
      <cc-import-details [recordId]="recordId"></cc-import-details>
      <div class="tags-wrapper">
        <cc-contact-tags *ngxPermissionsOnly="'TAGS_PERMISSION'"></cc-contact-tags>
      </div>
      <cc-contact-note [recordId]="recordId"></cc-contact-note>
    </div>
    <div class="details-content--right">
      <cc-contact-history [recordId]="recordId" [eventId]="eventId"></cc-contact-history>
    </div>
  </div>
</div>

